import L from 'leaflet';
import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Mousetrap from 'mousetrap';
import intl from 'react-intl-universal';

// eslint-disable-next-line
import Editable from 'leaflet-editable';
import ConfirmationPopup from './../ConfirmationPopup';

import './PolylineDraw.css';
import {PolyDraw} from "../PolygonDraw";


@inject("appStore")
@observer
class PolylineDraw extends PolyDraw {
    constructor(props) {
        super(props);
        this.polylineLayer = null;
        this.featureGroup = new L.FeatureGroup();
        this.polyline = null;
        this.state = {
            drawing: false
        };
    };

    startPoly() {
        this.polyline = this.props.appStore.mapState.element.editTools.startPolyline();
    }

    initializePoly() {
        this.polyline = new L.polyline(this.props.appStore.pendingState.element.position, {
            color: (this.props.appStore.pendingState.element.icon.color ? this.props.appStore.pendingState.element.icon.color: '#7ed321')
        });
        this.setState({
            direction: "forward"
        });
        this.polylineLayer = this.featureGroup.addLayer(this.polyline);
        this.polyline.enableEdit(this.props.appStore.mapState.element);
        this.addContinueButtons();
    }

    get vertices() {
        return this.polyline._latlngs.map((latlng) => {
            if (latlng.__vertex) return latlng.__vertex;
        }).filter(v => !!v)
    }


    get polyLayer() {
        return this.polylineLayer;
    }

    drawStart = (e) => {
        this.polylineLayer = e.layer;
        this.polylineLayer.setStyle({color: (this.props.appStore.pendingState.element.icon.color ? this.props.appStore.pendingState.element.icon.color: '#7ed321')});
        e.layer.addTo(this.props.appStore.mapState.element);
        this.props.appStore.tracking.event('Started Drawing Polyline');
    };
    drawEnd = () => {
        this.saveElement();
        this.addContinueButtons();
        this.setState({
            drawing: false
        });

        let latLngs = this.polylineLayer.toGeoJSON();
        if (latLngs.features) {
            this.props.appStore.setPendingElementPosition(latLngs.features[0].geometry.coordinates.map(longlat => {
                return {lat: longlat[1], lng: longlat[0]}
            }));
        } else {
            this.props.appStore.setPendingElementPosition(latLngs.geometry.coordinates.map(longlat => {
                return {lat: longlat[1], lng: longlat[0]}
            }));
        }
        if (!this.props.appStore.tryAutoSave()) {
            this.props.appStore.setSavePopup(true);
        }
    };
    addFinishButton = (index) => {
        let vertexes = this.polyline._latlngs.map((latlng) => {
            return latlng.__vertex
        });

        vertexes.forEach(function (vertex) {
            vertex._icon.classList.remove('finish-button');
            if (index === vertex.getIndex()) {
                vertex._icon.classList.add('finish-button');
            }
        });
    };
    addContinueButtons = () => {
        let vertexes = this.polyline._latlngs.map((latlng) => {
            return latlng.__vertex
        });

        vertexes.forEach(function (vertex) {
            vertex._icon.classList.remove('continue-button');
            if (vertex.getLastIndex() === vertex.getIndex()) {
                vertex._icon.classList.add('continue-button');
            } else if (0 === vertex.getIndex()) {
                vertex._icon.classList.add('continue-button');
            }
        });
    };
    saveElement = () => {
        if (this.polyline._latlngs.length > 1) {
            this.props.appStore.tracking.event('Saved Polyline');
            this.polyline.editor.tools.commitDrawing();
        }
    };
    eventHandlers = () => {
        this.props.appStore.mapState.element.on('editable:created', (e) => {
            this.drawStart(e);
            this.setState({
               // drawing: true,
               direction: 'forward'
            });
        });

        this.props.appStore.mapState.element.on('editable:drawing:end', (e) => {
            this.drawEnd(e);
        });

        this.props.appStore.mapState.element.on('editable:vertex:click', (e) => {
            // console.log('editable:vertex:click');
            e.cancel();
            L.DomEvent.stopPropagation(e.originalEvent);
            let vertexIndex = e.vertex.getIndex();
            if (e.vertex.latlngs[vertexIndex].__vertex._icon.classList.contains('continue-button')) {
                e.vertex.latlngs[vertexIndex].__vertex._icon.classList.remove('continue-button');
                if (vertexIndex === e.vertex.getLastIndex()) {
                    this.setState({
                        drawing: true,
                        direction: "forward"
                    });
                    this.polyline.editor.continueForward();
                    this.addFinishButton(e.vertex.getLastIndex());
                } else if (vertexIndex === 0) {
                    this.setState({
                        drawing: true,
                        direction: "backward"
                    });
                    this.polyline.editor.continueBackward();
                    this.addFinishButton(0);
                }
            } else if (e.vertex.latlngs[vertexIndex].__vertex._icon.classList.contains('finish-button')) {
                e.vertex.latlngs[vertexIndex].__vertex._icon.classList.remove('finish-button');
                this.addContinueButtons();
                this.saveElement();
            } else {
                // Check for a last index > 1 to maintain a minimum of two points
                if (e.vertex.getLastIndex() > 1) {
                    if (e.vertex.latlngs[vertexIndex].__vertex._icon.classList.contains('pending-delete-button')) {
                        e.vertex.delete();
                    } else {
                        e.vertex.latlngs[vertexIndex].__vertex._icon.classList.add('pending-delete-button');
                    }
                }
            }
            this.applyMarkerClass();
            return false;
        });

        this.props.appStore.mapState.element.on('editable:vertex:mouseout', (e) => {
            let vertexIndex = e.vertex.getIndex();
            e.vertex._icon.innerHTML = '';
            if (e.vertex.latlngs[vertexIndex].__vertex._icon.classList.contains('pending-delete-button')) {
                e.vertex.latlngs[vertexIndex].__vertex._icon.classList.remove('pending-delete-button');
            }
        });

        this.props.appStore.mapState.element.on('editable:vertex:deleted', (e) => {
            if (this.state.direction === "forward") {
                this.addFinishButton(e.vertex.getLastIndex());
            } else {
                this.addFinishButton(0);
            }
            let vertexes = this.polyline._latlngs.map((latlng) => {
                return latlng.__vertex
            });
            vertexes.forEach((vertex) => {
                if (vertex.getLastIndex() === vertex.getIndex()) {
                    this.polyline.editor.tools.forwardLineGuide._latlngs[0] = vertex.latlng;
                    this.polyline.editor.tools.forwardLineGuide._bounds.extend(vertex.latlng);
                    this.polyline.editor.tools.forwardLineGuide.redraw();
                }
            });
            this.applyMarkerClass();
        });

        // this.props.appStore.mapState.element.on('editable:vertex:new', (e) => {
        //
        //
        //
        // });

        this.props.appStore.mapState.element.on('editable:vertex:new', (e) => {
            // console.log('editable:vertex:new');
            if (this.state.direction === "forward") {
                this.addFinishButton(e.vertex.getLastIndex());
            } else {
                this.addFinishButton(0);
            }
            if (!this.state.drawing) {
                this.setState({
                    drawing: true
                });
            }
            this.applyMarkerClass(e.vertex);//not too big a deal - because it only happens on click, not drag (and may appear intentional) but this is not being applied
            this.props.appStore.disableDrawer(true);
        });

        this.props.appStore.mapState.element.on('editable:editing', (e) => {
            let pElement = this.props.appStore.pendingState.element;
            e.editTools.forwardLineGuide.options.color = (pElement.icon.color ? pElement.icon.color: '#7ed321');
            let latLngs = this.polylineLayer.toGeoJSON();
            if (latLngs.geometry) {
                this.props.appStore.setPendingElementPosition(latLngs.geometry.coordinates.map(longlat => {
                    return {lat: longlat[1], lng: longlat[0]}
                }));
            } else {
                this.props.appStore.setPendingElementPosition(latLngs.features[0].geometry.coordinates.map(longlat => {
                    return {lat: longlat[1], lng: longlat[0]}
                }));
            }

            this.applyMarkerClass();
        });
    };

    render() {
        return this.renderContent("PolylineDraw");
    }
}

export default PolylineDraw;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PolylineDraw/index.js